<template>
  <div class="hidden md:flex items-center justify-center flex-1 px-4">
    <div class="relative w-full max-w-md">
      <div class="flex items-center bg-gray-100 border border-gray-300 rounded-lg overflow-hidden hover:border-primary transition duration-300">
        <input
          v-model="searchQuery"
          @keyup.enter="performSearch"
          @input="handleInput"
          @focus="showSuggestions = true"
          @blur="closeSuggestions"
          type="text"
          placeholder="Search products..."
          class="w-full px-3 py-2 bg-gray-100 text-gray-800 text-sm focus:outline-none"
        />
        <button
          @click="performSearch"
          class="px-3 py-2 text-gray-600 hover:text-primary transition duration-300"
        >
          <fa-icon icon="search" size="sm" />
        </button>
      </div>

      <!-- Suggestions -->
      <transition
        enter-active-class="transition duration-150 ease-out transform"
        enter-from-class="scale-95 opacity-0"
        enter-to-class="scale-100 opacity-100"
        leave-active-class="transition duration-150 ease-in transform"
        leave-from-class="scale-100 opacity-100"
        leave-to-class="scale-95 opacity-0"
      >
        <div
          v-if="showSuggestions && suggestions.length > 0"
          class="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-64 overflow-y-auto"
        >
          <div
            v-for="product in suggestions.slice(0, 4)"
            :key="product.id"
            @click="selectProduct(product)"
            class="px-3 py-2 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0 flex items-center space-x-2 text-sm"
          >
            <img
              v-if="product.images && product.images.length > 0"
              :src="baseProductUrl + product.images[0].url"
              alt="product"
              class="w-8 h-8 object-cover rounded"
            />
            <div class="flex-1 min-w-0">
              <p class="font-medium text-gray-800 truncate">{{ product.name }}</p>
              <p class="text-primary font-semibold text-xs">${{ product.price }}</p>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import instance from "@/axios";

export default {
  name: "SearchInput",
  data() {
    return {
      searchQuery: "",
      showSuggestions: false,
      suggestions: [],
      baseProductUrl: this.$store.state.baseProductUrl,
      searchTimeout: null,
    };
  },
  methods: {
    handleInput() {
      // Debounce search
      clearTimeout(this.searchTimeout);
      if (this.searchQuery.trim().length === 0) {
        this.suggestions = [];
        return;
      }
      
      this.searchTimeout = setTimeout(() => {
        this.fetchSuggestions();
      }, 300);
    },
    async fetchSuggestions() {
      try {
        if (this.searchQuery.trim().length === 0) {
          this.suggestions = [];
          return;
        }
        
        const res = await instance.get("products/search", {
          params: { q: this.searchQuery }
        });
        
        console.log(`Search results for "${this.searchQuery}":`, res.data);
        this.suggestions = Array.isArray(res.data) ? res.data : [];
      } catch (err) {
        console.error('Search suggestions error:', err);
        this.suggestions = [];
      }
    },
    performSearch() {
      if (this.searchQuery.trim()) {
        this.$router.push(`/search?q=${encodeURIComponent(this.searchQuery)}`);
        this.searchQuery = "";
        this.suggestions = [];
        this.showSuggestions = false;
      }
    },
    selectProduct(product) {
      this.$router.push(`/single/${product.id}`);
      this.searchQuery = "";
      this.suggestions = [];
      this.showSuggestions = false;
    },
    closeSuggestions() {
      // Delay to allow click on suggestion
      setTimeout(() => {
        this.showSuggestions = false;
      }, 100);
    },
  },
};
</script>

<style scoped></style>
